import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.99935 11.3337V12.0003C9.99935 13.1049 9.10392 14.0003 7.99935 14.0003C6.89478 14.0003 5.99935 13.1049 5.99935 12.0003V11.3337M9.99935 11.3337H5.99935M9.99935 11.3337H12.393C12.648 11.3337 12.7762 11.3337 12.8794 11.2988C13.0767 11.2323 13.231 11.0774 13.2975 10.8802C13.3325 10.7765 13.3325 10.648 13.3325 10.391C13.3325 10.2785 13.3324 10.2222 13.3236 10.1686C13.3069 10.0673 13.2676 9.97122 13.2077 9.8878C13.1761 9.84373 13.1358 9.8035 13.0566 9.72421L12.7969 9.46452C12.7131 9.38073 12.666 9.26708 12.666 9.1486V6.66699C12.666 4.08966 10.5767 2.00032 7.99935 2.00033C5.42203 2.00033 3.33268 4.08967 3.33268 6.66699V9.14861C3.33268 9.2671 3.28551 9.38073 3.20173 9.46452L2.94206 9.72419C2.86253 9.80372 2.82271 9.84369 2.79102 9.88782C2.73112 9.97124 2.69145 10.0673 2.67482 10.1686C2.66602 10.2222 2.66602 10.2785 2.66602 10.391C2.66602 10.648 2.66602 10.7765 2.70098 10.8802C2.76752 11.0774 2.92255 11.2323 3.11979 11.2988C3.22306 11.3337 3.35069 11.3337 3.60572 11.3337H5.99935M12.0117 1.34277C12.9312 2.03565 13.6556 2.95484 14.1143 4.01082M3.98733 1.34277C3.06785 2.03565 2.34348 2.95484 1.88477 4.01082",
      stroke: "#64748B",
      "stroke-width": "1.2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }